import { Socket } from "phoenix";

// And connect to the path in "lib/collava_web/endpoint.ex". We pass the
// token for authentication. Read below how it should be used.

// this is used on the connec/3 function in the user_socket.ex file
let socket = new Socket("/publicsocket", { params: {} });

// When you connect, you'll often need to authenticate the client.
// For example, imagine you have an authentication plug, `MyAuth`,
// which authenticates the session and assigns a `:current_user`.
// If the current user exists you can assign the user's token in
// the connection for use in the layout.
//
// In your "lib/collava_web/router.ex":
//
//     pipeline :browser do
//       ...
//       plug MyAuth
//       plug :put_user_token
//     end
//
//     defp put_user_token(conn, _) do
//       if current_user = conn.assigns[:current_user] do
//         token = Phoenix.Token.sign(conn, "user socket", current_user.id)
//         assign(conn, :user_token, token)
//       else
//         conn
//       end
//     end
//
// Now you need to pass this token to JavaScript. You can do so
// inside a script tag in "lib/collava_web/templates/layout/app.html.heex":
//
//     <script>window.userToken = "<%= assigns[:user_token] %>";</script>
//
// You will need to verify the user token in the "connect/3" function
// in "lib/collava_web/channels/user_socket.ex":
//
//     def connect(%{"token" => token}, socket, _connect_info) do
//       # max_age: 1209600 is equivalent to two weeks in seconds
//       case Phoenix.Token.verify(socket, "user socket", token, max_age: 1_209_600) do
//         {:ok, user_id} ->
//           {:ok, assign(socket, :user, user_id)}
//
//         {:error, reason} ->
//           :error
//       end
//     end
//
// Finally, connect to the socket:

socket.connect();

let channel = socket.channel("notifications:global", {});
let notificationsContainer = document.querySelector("#notifications-container");

channel.on("new_public_data", (payload) => {
  let outerDiv = document.createElement("div");
  let innerDiv = document.createElement("div");
  let div_notification = document.createElement("div");
  let div_title = document.createElement("div");
  let div_content = document.createElement("div");
  let a_link = document.createElement("a");

  outerDiv.id = `toast-${Math.random().toString(36).substring(2, 28)}`;
  outerDiv.className = "toast-body";
  outerDiv.role = "alert";
  innerDiv.className = "flex py-2 px-4";

  a_link.href = `${payload.link}?utm_source=public_notification&utm_medium=notification`;
  a_link.target = "_blank";
  a_link.innerHTML = `${payload.title}`;

  div_title.className = "toast-title";

  div_content.innerText = `${payload.content}`;
  div_content.className = "toast-content";

  div_title.appendChild(a_link);
  div_notification.appendChild(div_title);
  div_notification.appendChild(div_content);
  innerDiv.appendChild(div_notification);
  outerDiv.appendChild(innerDiv);

  notificationsContainer.appendChild(outerDiv);

  setTimeout(() => {
    outerDiv.classList.remove("slide-in", "fade-in");
    outerDiv.classList.add("slide-out");
    setTimeout(() => {
      outerDiv.remove();
    }, 500);
  }, 12000);
});

channel.join();
export default socket;
